import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import {
  DashboardCardNameEnum,
  DashboardCardTemplateTypeEnum,
  DATA_E2E_KEY,
  IStyledAttributes,
} from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const UnimplementedContentStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "dashboard-unimplemented-content",
})`
  background-color: ${rydeColors.white};
  position: relative;
  top: 40%;
  font-size: 18px;
  transform: translateY(-50%);
  justify-items: center;
  text-align: center;
  align-items: center;
`;

export interface IUnimplementedContentProps {
  cardType: DashboardCardTemplateTypeEnum;
  cardName: DashboardCardNameEnum;
}

export const CardUnimplementedContentTemplate: FC<
  IUnimplementedContentProps
> = ({ cardName, cardType }) => {
  const { t } = useTranslation();

  return (
    <UnimplementedContentStyled>
      {t("errors.dashboardUnimplementedCardError")}
    </UnimplementedContentStyled>
  );
};
